import React from "react";
import { Box } from "@mui/material";

import Signupgraphic from "../../assets/login.png";
// import Logingraphic from "../../assets/logingraphic.png";

import { Typography } from "@mui/material";
import Register from "./Register";

export const SignUp = () => {
	return (
		<>
			<Box
				sx={{
					height: "100%",
					display: "flex",
					// flexWrap: "wrap",
					flexDirection: { xs: "column", md: "row" },
					padding: { xs: 1, md: 2 },
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexWrap: "wrap",
						flexDirection: "center",
						background: "#FFFFFF",
						boxShadow: "0px 15px 55px 1px #E6E6E6",
						borderRadius: "12px",
						width: { xs: "100%", md: "80%" },
						// height: "calc(100vh - 100px)",

						mx: "auto",
					}}
				>
					<Box
						sx={{
							width: { xs: "100%", md: "50%" },
							// height: "calc(100vh - 70px)",

							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							px: { xs: 1, md: 1 },
							alignItems: "center",
							alignContent: "center",
						}}
					>
						<Register />
					</Box>
					<Box
						sx={{
							width: { xs: "100%", md: "500px" },
							display: { xs: "none", md: "flex" },
							flexDirection: "column",
							// px: { xs: 1, md: 2 },
						}}
					>
						<Box
							component="img"
							src={Signupgraphic}
							sx={{
								objectFit: "contain",
								height: "calc(100vh - 70px)",
							}}
						/>
					</Box>
				</Box>
			</Box>
		</>
	);
};
